module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Activity_EventCalendarViewerNew":{"baseRowNumber":[{"value":9,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"additionalApiParams.transitParameters.v1":[{"value":"ykYa8ALmUD","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"filter1.embed.container":[{"value":"#filter-container-1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"filter2.embed.container":[{"value":"#filter-container-2","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"list.embed.container":[{"value":"#eventlist-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"list.onAddedToDom":[{"value":function () {
$(this.element[0]).addClass('fadeIn animated');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"widgets.eventFilter.limit":[{"value":18,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}],"hooks.onPrepareResponse":[{"value":function (data) {
var n = 0;
var rowNum = this.getOption('baseRowNumber');
fox.each(data.response.collection, function (data, i) {
n++
data.templateOptions = {cName: 'p' + n};
if (n%rowNum == 0) {
n = 0;
};
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107026},"path":"~.Activity_EventCalendarViewerNew","_fox_":1}]},"~.Activity_EventCalendarViewerNew #eventList":{"columns":[{"value":["#firts-column","#second-column"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.Activity_EventCalendarViewerNew #eventList","_fox_":1}],"hooks.onTreatRow":[{"value":function (data) {
var wClass, w, wAlias, cols;
var rowNum = this.getParent().getOption('baseRowNumber');
var cols = fox.clone(this.getOption('columns'));
this.def.embed.container = cols[(data.key < rowNum ? 0 : 1)];
wClass = data.val.widget || this.getOption('wClass') || 'Widget';
wAlias = ['activity', data.key].join('_');
w = this.getEmbeddedWidget(wAlias);
if (!w) {
if (fox.isObject(data.val.typedParams) && ('length' in data.val.typedParams)) {
data.val.typedParams._length = data.val.typedParams.length;
delete data.val.typedParams.length;
}
w = this.embedWidget(wAlias, wClass, fox.merge(data.val, this.def))
w.run();
} else {
w.activate();
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107048},"path":"~.Activity_EventCalendarViewerNew #eventList","_fox_":1}]},"~.Activity_Event_MainEventNew":{"template":[{"value":"activity_event_card_main","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107050},"path":"~.Activity_Event_MainEventNew","_fox_":1}],"childContainer":[{"value":"#event-body-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":"~.Activity_Event_MainEventNew","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/activity.js
// module id = 1012
// module chunks = 4